// Angular
import { Directive, ElementRef, HostListener, Renderer2, OnDestroy, input, inject } from '@angular/core';

@Directive({
    selector: '[CopyToClipboard]'
})
export class CopyToClipboardDirective implements OnDestroy {
    /**
     * The input element whose value will be copied to the clipboard.
     */
    readonly copyInput = input.required<string>();

    // Private properties
    private originalIconClass = 'flaticon2-copy';
    private successIconClass = 'flaticon2-check-mark';
    private timeoutId: ReturnType<typeof setTimeout> | null = null;
    private el = inject(ElementRef);
    private renderer = inject(Renderer2);

    @HostListener('click')
    async onClick() {
        if (!this.copyInput) return;

        // Copy input value to clipboard
        try {
            await navigator.clipboard.writeText(this.copyInput());
        } catch (err) {
            console.error('Copy failed', err);
            return;
        }

        // Swap icon to "check"
        this.renderer.removeClass(this.el.nativeElement, this.originalIconClass);
        this.renderer.addClass(this.el.nativeElement, this.successIconClass);

        // Reset after 5 seconds
        if (this.timeoutId) clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.renderer.removeClass(this.el.nativeElement, this.successIconClass);
            this.renderer.addClass(this.el.nativeElement, this.originalIconClass);
            this.timeoutId = null;
        }, 2000);
    }

    ngOnDestroy() {
        // Prevent timeout leaks
        if (this.timeoutId) clearTimeout(this.timeoutId);
    }
}
